import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Spacings, BgColors, BorderColors } from '../../../../styleConstants';

const SocialImage = styled.div`
  width: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  transition: background-color 200ms ease;
  background-color: ${BgColors.WHITE};
  border: 1px solid ${BorderColors.GREY};
  box-sizing: content-box;
  cursor: pointer;
  path {
    fill: ${({ $color }) => $color};
  }
  &:hover {
    background-color: ${({ $color }) => $color};
    path {
      fill: ${BgColors.WHITE};
    }
  }
`;

const SocialIcon = ({ socialIcon, onClick }) => {
  const Icon = socialIcon.icon;
  return (
    <SocialImage $color={socialIcon.color} onClick={onClick}>
      <Icon />
    </SocialImage>
  );
};

SocialIcon.propTypes = {
  socialIcon: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired
};

export default SocialIcon;
